"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataDelegateRoleBeet = exports.MetadataDelegateRole = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
var MetadataDelegateRole;
(function (MetadataDelegateRole) {
    MetadataDelegateRole[MetadataDelegateRole["AuthorityItem"] = 0] = "AuthorityItem";
    MetadataDelegateRole[MetadataDelegateRole["Collection"] = 1] = "Collection";
    MetadataDelegateRole[MetadataDelegateRole["Use"] = 2] = "Use";
    MetadataDelegateRole[MetadataDelegateRole["Data"] = 3] = "Data";
    MetadataDelegateRole[MetadataDelegateRole["ProgrammableConfig"] = 4] = "ProgrammableConfig";
    MetadataDelegateRole[MetadataDelegateRole["DataItem"] = 5] = "DataItem";
    MetadataDelegateRole[MetadataDelegateRole["CollectionItem"] = 6] = "CollectionItem";
    MetadataDelegateRole[MetadataDelegateRole["ProgrammableConfigItem"] = 7] = "ProgrammableConfigItem";
})(MetadataDelegateRole = exports.MetadataDelegateRole || (exports.MetadataDelegateRole = {}));
exports.metadataDelegateRoleBeet = beet.fixedScalarEnum(MetadataDelegateRole);
//# sourceMappingURL=MetadataDelegateRole.js.map